// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"sectionWrapper-1hU8K","sectionWrapper__title":"sectionWrapper__title-BVPgS","sectionWrapper__content":"sectionWrapper__content-3oCj_"};